// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"1fa9fc2edeff1be26773","966":"89a2ee962fe0b0179ef6"}[chunkId] + ".js";
};